

const atualizarEndereco = (state, endereco) => {
    state.endereco = endereco;
}

export default {
    atualizarEndereco
}